import { render, staticRenderFns } from "./ProjectGrid.vue?vue&type=template&id=d56d4906&"
import script from "./ProjectGrid.vue?vue&type=script&lang=js&"
export * from "./ProjectGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports